module.exports = __webpack_public_path__ + "img/link.45b3fcb3.svg";